import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { isError } from "@nju/result";
import { IInvoiceResult } from "./types";

interface IParams {
  invoiceId: string;
}

export async function sendInvoiceOnMail(
  data: IParams,
): Promise<IInvoiceResult> {
  const result = await client(
    `${
      process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST || "unknown"
    }/users/invoices/duplicate`,
    {
      method: "post",
      json: data,
      headers: {
        version: "2",
        apikey: process.env.NEXT_PUBLIC_APIKEY || "unknown",
      },
    },
  );

  if (isError(result)) {
    Bugsnag.notify(result.err);
    return result;
  }

  return result;
}
